module.exports = __webpack_public_path__ + "static/CircularPro-BlackItalic.ab099c44.ttf";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-BlackItalic.ttf
// module id = 715
// module chunks = 168707334958949